<template>
  <div class="category-filter">
    <span class="category-filter__title">{{$t('CATEGORIES')}}:</span>
    <a-button-group class="cemetery-list__buttons">
      <a-button
          v-for="(filterItem, index) in categoriesList"
          v-if="filterItem.status"
          :key="index"
          :class="{'active': isSelectedCategory(filterItem.id)}"
          class="category-filter__button"
          :ref="`category__${filterItem.id}`"
          @click="toggleSelectedIds(filterItem.id)">
        {{ filterItem.name }}
        <a-icon v-if="isSelectedCategory(filterItem.id)" type="check"/>
      </a-button>
    </a-button-group>
  </div>
</template>

<script>
import { mapActions, mapGetters, } from 'vuex'

export default {
  name: "categories-filter",

  computed: {
    ...mapGetters({
      categoriesList: 'categories/categoriesList',
      isSelectedCategory: 'categories/isSelectedCategory',
    })
  },
  methods: {
    ...mapActions({
      getCategoriesList: 'categories/getCategoriesList',
      toggleSelectedIds: 'categories/toggleSelectedIds',
    }),
  },

  mounted() {
    this.getCategoriesList()
  }
}
</script>

<style lang="scss">
.category-filter {
  margin: 15px 55px 10px;

  &__title {
    padding-right: 10px;
    font-size: 16px;
    font-weight: 700;
  }

  &__button {
    margin-right: 5px;
    margin-bottom: 5px;
    text-transform: capitalize;

    &:active {
      color: #40a9ff;
      background-color: #fff;
      border-color: #40a9ff;
    }
  }
}

@media (max-width: 768px) {
  .category-filter {
    margin: 16px 20px;
  }
}
</style>
